import type { ConvertWebApiDeclaredToActual } from '@zola-helpers/client/dist/es/@types/svc-web-api';
import type { WProjectCustomizationFullView } from '@zola/svc-web-api-ts-client';
import { CARD_TYPE_MAP } from '../constants/cardTypes';

type PlaceCardCustomization = Pick<
  WProjectCustomizationFullView | ConvertWebApiDeclaredToActual<WProjectCustomizationFullView>,
  'type' | 'should_print_guest_names' | 'should_print_table_names'
>;

/**
 * Filters elements out of a place card that should not be displayed based
 * on the customization.  For instance, both guest and table name printing can
 * be turned off.  If this is the case, we should not display the element.
 *
 * @param tag
 * @param customization
 * @returns
 */
export const placeCardFilter = <T extends PlaceCardCustomization>(
  tag: string | null | undefined,
  customization: T
): boolean => {
  const {
    type,
    should_print_guest_names: shouldPrintGuestNames,
    should_print_table_names: shouldPrintTableNames,
  } = customization;

  if (type !== CARD_TYPE_MAP.place) return true;

  if (tag === 'PLACE_CARD_GUEST') return Boolean(shouldPrintGuestNames);

  if (tag === 'PLACE_CARD_TABLE' || tag === 'PLACE_CARD_STATIC_TABLE_ELEMENT')
    return Boolean(shouldPrintTableNames);

  return true;
};
